import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '../Grid/index.js';
import { Money } from '../index.js';
import GrowthDisplay from './GrowthDisplay.js';
import { StatStyled, Total } from './Stat.js';
const PaymentPlansStats = (props) => {
    const { paymentPlans } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(StatStyled, { header: lang.home.paymentPlans },
        React.createElement(Row, null,
            React.createElement(Col, { size: "md", width: "6" },
                React.createElement("p", null, lang.home.today),
                React.createElement("h3", { className: "this-one" },
                    paymentPlans.todayCount,
                    React.createElement("span", { className: "meta" },
                        React.createElement(GrowthDisplay, { prev: paymentPlans.yesterdayCount || 0, curr: paymentPlans.todayCount || 0 }),
                        React.createElement("span", null,
                            lang.home.yesterday,
                            " ",
                            paymentPlans.yesterdayCount)))),
            React.createElement(Col, { size: "md", width: "6" },
                React.createElement("p", null, lang.home.thisMonth),
                React.createElement("h3", { className: "this-one" },
                    paymentPlans.thisMonthCount,
                    React.createElement("span", { className: "meta" },
                        React.createElement(GrowthDisplay, { prev: paymentPlans.lastMonthCount || 0, curr: paymentPlans.thisMonthCount || 0 }),
                        React.createElement("span", null,
                            lang.home.lastMonth,
                            " ",
                            paymentPlans.lastMonthCount)))),
            React.createElement(Col, { size: "md", width: "12" },
                React.createElement(Total, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.totalPlans),
                            React.createElement("div", { className: "total-value" }, paymentPlans.totalCount)),
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.settledAmountLastMonth),
                            React.createElement("div", { className: "total-value" },
                                React.createElement(Money, { amount: paymentPlans.lastMonthAmount }))),
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.totalActivePlans),
                            React.createElement("div", { className: "total-value" }, paymentPlans.totalActiveCount)),
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.settledAmountThisMonth),
                            React.createElement("div", { className: "total-value" },
                                React.createElement(Money, { amount: paymentPlans.thisMonthAmount }))),
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.totalSettledAmount),
                            React.createElement("div", { className: "total-value" },
                                React.createElement(Money, { amount: paymentPlans.totalAmount }))),
                        React.createElement(Col, { size: "md", width: "6", className: "total-container" },
                            React.createElement("div", { className: "total-key" }, lang.home.plannedAmountNextMonth),
                            React.createElement("div", { className: "total-value" },
                                React.createElement(Money, { amount: paymentPlans.nextMonthAmount })))))))));
};
export default PaymentPlansStats;
//# sourceMappingURL=PaymentPlansStats.js.map